import { TextSize } from "@gx/dls/text/Text";

export enum BaseHeaderSize {
  SMALL = "SMALL",
  MEDIUM = "MEDIUM",
  LARGE = "LARGE",
}

export const BASE_HEADER_SIZE_TO_TITLE_SIZE_MAP: Record<BaseHeaderSize, TextSize> = {
  [BaseHeaderSize.SMALL]: TextSize.BODY_MD,
  [BaseHeaderSize.MEDIUM]: TextSize.BODY_LG,
  [BaseHeaderSize.LARGE]: TextSize.HEADING_SM,
};
